import { useContext } from 'react';

import { createLocalization } from '@suntex.fim/utils';

import { FrameworkContext } from '../context';

export function useFramework(): FrameworkContext & {
  localization: ReturnType<typeof createLocalization>;
} {
  const context = useContext(FrameworkContext);

  if (!context) {
    throw new Error('Invalid hook call');
  }

  return { ...context, localization: createLocalization(context.locale) };
}
